import { useCallback, useState } from "react";
import { sortData, sortDataByStatus } from "../../utils/utils";
import "./table.css";

const Table = ({ columns, children, setCertificationList }) => {
  const [sortOrder, setSortOrder] = useState("asc");
  const [sortKey, setSortKey] = useState("certificationCode");

  const handleSort = useCallback(
    (key) => {
      setCertificationList((prevList) => {
        let sortedData;
        if (key === "certificationStatus") {
          sortedData = sortDataByStatus([...prevList]);
        } else {
          sortedData = sortData([...prevList], key);
        }
        const newSortOrder = sortOrder === "asc" ? "desc" : "asc";
        setSortKey(key);
        setSortOrder(newSortOrder);
        localStorage.setItem("sortedKey", key);
        return newSortOrder === "asc" ? sortedData : sortedData.reverse();
      });
    },
    [sortOrder, setCertificationList]
  );

  console.log(columns.map((column) => console.log(column)));
  return (
    <>
      <div className="table-wrapper relative overfow-x-auto shadow-sm mb-4 overflow-y-auto rounded-xl">
        <table
          id="adminusertable"
          className="table-auto border rounded-md w-full"
        >
          <thead className="text-white bg-coc-blue border rounded-lg sticky top-0">
            <tr className="h-[70px] w-[200px]">
              <th className="w-[20px]"></th>
              {columns &&
                columns.length > 0 &&
                columns.map((column) => {
                  return (
                    <th
                      className={`${
                        column.className ||
                        "font-light text-white text-sm whitespace-nowrap"
                      } resizable`}
                      key={column.code}
                      id={column.code}
                    >
                      {column.code && (
                        <svg
                          onClick={() => handleSort(column.code)}
                          className={`inline ml-2 w-4 h-4 ${
                            sortOrder === "desc" && sortKey === column.code
                              ? "rotate-180"
                              : ""
                          }`}
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path
                            fillRule="evenodd"
                            d="M10 2a.75.75 0 01.75.75v12.59l1.95-2.1a.75.75 0 111.1 1.02l-3.25 3.5a.75.75 0 01-1.1 0l-3.25-3.5a.75.75 0 111.1-1.02l1.95 2.1V2.75A.75.75 0 0110 2z"
                            clipRule="evenodd"
                          />
                        </svg>
                      )}

                      {column.name}
                    </th>
                  );
                })}
            </tr>
          </thead>
          <tbody className="w-full">{children}</tbody>
        </table>
      </div>
    </>
  );
};

export default Table;
